import React from 'react';
import { Input as AntInput } from 'antd';

const priceRegex = /^\d*\.?\d{0,2}$/;

const Input = ({ value, onChange, ...props }) => {
  const handleChange = (e) => {
    const value = e.target.value?.replace(/\s+/g, '').replace(/,/g, '.');

    if (!priceRegex.test(value)) return;

    onChange({ price: value });
  };

  return (
    <AntInput
      {...props}
      addonAfter="₽"
      value={value}
      onChange={handleChange}
    />
  );
};

export default Input;
